@let t = timecard();
@let cols = columns();
@let dateLabel = t ? (t | bringozFullDate:'clockInTime') : (date() | date:'MM/dd/yy');
<div class="tr layout-row layout-align-start-center table-row child-row"
     [class.odd]="index() % 2 === 1"
     [class.empty-row]="!t"
     [class.status-approved]="isApproved()"
     [class.status-infeasible]="t?.hasInfeasibility">

  <!--Day Name (indented) with tree connector + checkbox-->
  <div class="td col-name layout-row layout-align-start-center">
    <div class="tree-connector">
      @if (isLastChild()) {
        <!-- Last child: connector without continuation line -->
        <bz-icon class="tree-icon" [icon]="icons.lastChild"></bz-icon>
      } @else {
        <!-- Non-last child: connector with continuation line -->
        <bz-icon class="tree-icon" [icon]="icons.child"></bz-icon>
      }
    </div>
    <bz-checkbox class="checkbox-spacing" size="sm"
                 appBringozIdGenerator="timecard-entry-checkbox"
                 [disabled]="!t"
                 [checked]="isSelected()"
                 [ariaLabel]="dayName() + ' ' + dateLabel"
                 (checkedChange)="onCheckboxToggle()">
    </bz-checkbox>
    <a class="br-link-1 text-ellipsis cursor-pointer"
       [appBringozTooltip]="dayName() + ' ' + dateLabel"
       [tooltipPlacement]="'top'" ngbTooltip
       (click)="onRowSelect()">
      {{ dayName() }} {{ dateLabel }}
    </a>
  </div>

  <!--Status-->
  @if (cols?.status?.enabled) {
    <div class="td col-status layout-row layout-align-start-center">
      @if (t) {
        <bz-tag [tone]="t.status | timecardStatusTone"
                [ngbTooltip]="statusTooltipTmpl"
                openDelay="300"
                triggers="hover"
                container="body">{{ t.status }}</bz-tag>
        @if (t.hasInfeasibility) {
          <bz-tag tone="danger">{{ 'Infeasible' | translate }}</bz-tag>
        }

        <ng-template #statusTooltipTmpl>
          <timecard-status-tooltip [timeCardIds]="[t.id]"></timecard-status-tooltip>
        </ng-template>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Employee ID (empty for child rows)-->
  @if (cols?.employeeId?.enabled) {
    <div class="td col-employeeId layout-row layout-align-start-center">
      <span class="br-body-2 gray-102">-</span>
    </div>
  }

  <!--Employee Zip (empty for child rows)-->
  @if (cols?.employeeZip?.enabled) {
    <div class="td col-employeeZip layout-row layout-align-start-center">
      <span class="br-body-2 gray-102">-</span>
    </div>
  }

  <!--Job Title-->
  @if (cols?.jobTitle?.enabled) {
    <div class="td col-jobTitle layout-row layout-align-start-center">
      @if (t) {
        <app-bringoz-tags [tags]="t.agentReference?.tags" [maxTags]="1" [isShowTagDescriptions]="true"></app-bringoz-tags>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Branch-->
  @if (cols?.branch?.enabled) {
    <div class="td col-branch layout-row layout-align-start-center">
      @if (t) {
        <branches-indicator [branches]="t.branchReferences"></branches-indicator>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Distance-->
  @if (cols?.distance?.enabled) {
    <div class="td col-distance layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.reportedData?.totals?.totalDistanceMeter | bringozDistance }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Speed-->
  @if (cols?.mph?.enabled) {
    <div class="td col-mph layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.reportedData?.totals?.speedKmh | bringozSpeed }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Service Time-->
  @if (cols?.serviceTime?.enabled) {
    <div class="td col-serviceTime layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.reportedData?.totals?.totalServiceTimeDurationMillis | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Drive Time-->
  @if (cols?.driveTime?.enabled) {
    <div class="td col-driveTime layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.reportedData?.totals?.totalTravelTimeDurationMillis | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Admin Time-->
  @if (cols?.adminTime?.enabled) {
    <div class="td col-adminTime layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.adminTime | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--PTO-->
  @if (cols?.pto?.enabled) {
    <div class="td col-pto layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ 0 | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Paid Time-->
  @if (cols?.paidTime?.enabled) {
    <div class="td col-paidTime layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.timeCardPaidTime?.totalTime | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Planned Time-->
  @if (cols?.plannedTime?.enabled) {
    <div class="td col-plannedTime layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.plannedData?.totals?.totalServiceTimeDurationMillis | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Stops-->
  @if (cols?.stops?.enabled) {
    <div class="td col-stops layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.reportedData?.totals?.totalStopsCount || 0 }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Break-->
  @if (cols?.break?.enabled) {
    <div class="td col-break layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">{{ t.reportedData?.totals?.totalBreakDurationMillis | bringozDurationExact }}</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

  <!--Off-->
  @if (cols?.off?.enabled) {
    <div class="td col-off layout-row layout-align-start-center">
      @if (t) {
        <span class="br-body-2 gray-101">00:00:00</span>
      } @else {
        <span class="br-body-2 gray-102">-</span>
      }
    </div>
  }

</div>
